var _path, _rect, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstBenefit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4194 24.9453L25.4158 24.8604L24.4194 24.9453ZM40.5799 24.9453L41.5763 25.0303L40.5799 24.9453ZM24.2785 23.2918L24.0954 22.3087L23.2051 22.4745L23.2821 23.3768L24.2785 23.2918ZM32.4997 31.5002C28.828 31.5002 25.7375 28.6334 25.4158 24.8604L23.4231 25.0303C23.8303 29.8059 27.7571 33.5002 32.4997 33.5002V31.5002ZM39.5835 24.8604C39.2618 28.6334 36.1713 31.5002 32.4997 31.5002V33.5002C37.2422 33.5002 41.1691 29.8059 41.5763 25.0303L39.5835 24.8604ZM25.4158 24.8604L25.2748 23.2069L23.2821 23.3768L23.4231 25.0303L25.4158 24.8604ZM32.4997 6.5835C27.5532 6.5835 23.5483 10.2995 22.844 15.0192L24.8221 15.3144C25.3882 11.5206 28.5972 8.5835 32.4997 8.5835V6.5835ZM24.4615 24.2749C25.0407 24.1671 26.4368 23.7753 27.7162 22.9171C29.0088 22.0501 30.3125 20.6072 30.3125 18.4168H28.3125C28.3125 19.6931 27.5841 20.5975 26.6021 21.2561C25.6069 21.9237 24.486 22.236 24.0954 22.3087L24.4615 24.2749ZM32.4997 8.5835C36.4021 8.5835 39.6112 11.5206 40.1773 15.3144L42.1554 15.0192C41.4511 10.2995 37.4461 6.5835 32.4997 6.5835V8.5835ZM40.1402 18.3319L39.5835 24.8604L41.5763 25.0303L42.133 18.5018L40.1402 18.3319Z",
    fill: "#2295EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 15.167,
    width: 32.5,
    height: 3.25,
    rx: 1.625,
    stroke: "#2295EF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0837 30.0002C22.2489 30.0002 21.7108 30.0002 21.7108 30.0002C21.7108 30.0002 21.3454 24.4353 22.7256 18.417",
    stroke: "#2295EF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9163 30.0002C42.7511 30.0002 43.2892 30.0002 43.2892 30.0002C43.2892 30.0002 43.6549 24.4353 42.2748 18.417",
    stroke: "#2295EF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41.0835C18 37.3571 20.9469 34.319 24.6373 34.1724C29.4593 37.1347 35.5405 37.1347 40.3625 34.1724C44.0531 34.319 47 37.3572 47 41.0837V56.0002H40.0833H32.4999H24.9166H18V41.0835Z",
    stroke: "#2295EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 46.042L4.74356 42.2984M1 46.042L4.74356 49.7856M1 46.042H11",
    stroke: "#2295EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46.042L60.2564 42.2984M64 46.042L60.2564 49.7856M64 46.042H54",
    stroke: "#2295EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstBenefit);
export default __webpack_public_path__ + "static/media/first_benefit.03a5dd06ad862be471cc4cf36875a3f4.svg";
export { ForwardRef as ReactComponent };